import { ValidSizes } from "../../utils/types";

type validTypes = 'vertical' | 'horizontal'

const sizeClasses: {
  [key in validTypes]: { [key in ValidSizes]: string }
} = {
  vertical: {
    '2xs': 'mt-2xs',
    'xs': 'mt-xs',
    'sm': 'mt-sm',
    'md': 'mt-md',
    'lg': 'mt-lg',
    'xl': 'mt-xl',
    '2xl': 'mt-2xl',
    '3xl': 'mt-3xl',
    '4xl': 'mt-4xl',
    '5xl': 'mt-5xl'
  },
  horizontal: {
    '2xs': 'ml-2xs',
    'xs': 'ml-xs',
    'sm': 'ml-sm',
    'md': 'ml-md',
    'lg': 'ml-lg',
    'xl': 'ml-xl',
    '2xl': 'ml-2xl',
    '3xl': 'ml-3xl',
    '4xl': 'ml-4xl',
    '5xl': 'ml-5xl'
  }
}

export interface Props {
    type?: validTypes,
    size?: ValidSizes
}

export const Spacer = (
  {
    type = 'vertical',
    size = 'sm'
  }: Props
) => {
  const widthClasses = type === 'vertical' ? 'w-full' : '';
  const marginClasses = sizeClasses[type][size];
  
  return (
      <div className={`${widthClasses} ${marginClasses}`}></div>
  );
};

export default Spacer;
